import { useFormContext } from 'react-hook-form';

import type { QConfigEditFormInput } from './qconfig-edit-form-schema';

export const useQConfigEditFormContext = useFormContext<QConfigEditFormInput>;
